import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HideAccessDirective } from './hide-access.directive';



@NgModule({
  declarations: [
    HideAccessDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HideAccessDirective
  ]
})
export class HideAccessModule { }
